import React from "react";

export default function Maintenance() {
    return (
        <div className="container-maintain">
            <div className="box">
                <div className="animation">
                    <div className="one spin-one" />
                    <div className="two spin-two" />
                    <div className="three spin-one" />
                </div>
                <p>Holding the Fort! Our website is taking a short breather to prepare for an influx of awesomeness.
                    <br />
                    We'll be back before you know it</p>
            </div>
        </div>
    );
}
